<template>
  <div
    class="modal fade"
    id="confirmModalDialog"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">
            {{ popup.title }}
          </h1>
          <button
            type="button"
            class="btn-icon-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <!-- Array Body (REDESIGNED) -->
        <div
          v-if="Array.isArray(popup.body)"
          class="modal-body clean-list-body"
        >
          <ul class="clean-file-list" aria-live="polite" role="list">
            <li
              v-for="(column, index) in popup.body"
              :key="index"
              class="clean-file-item"
            >
              <span class="file-number">{{ index + 1 }}.</span>
              <span class="file-text">{{ column }}</span>
            </li>
          </ul>
        </div>

        <!-- Non-Array Body -->
        <div v-else class="modal-body">
          <p>{{ popup.body }}</p>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            {{ popup.secondaryActionLabel }}
          </button>

          <button
            type="button"
            class="btn btn-danger"
            @click="executePrimaryAction(this.popup.data)"
            data-bs-dismiss="modal"
          >
            {{ popup.actionLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
// import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
export default {
  name: "ConfirmModal",
  props: {
    popup: {
      type: Object,
      required: true,
    },
  },

  mounted() {},

  methods: {
    executePrimaryAction(data) {
      this.$emit("executePrimaryAction", data);
    },
    openModal() {
      const modal = document.getElementById("confirmModalDialog");

      if (
        !document.body.contains(modal) ||
        modal.parentElement.tagName !== "BODY"
      ) {
        document.body.appendChild(modal);
      }

      // Initialize the Bootstrap modal
      const myModal = new Modal(modal, {
        keyboard: false,
      });

      // Show the modal
      myModal.show();
    },
  },
};
</script>

<style scoped>
/* Ensure consistent box sizing */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Modal body container: vertical scrolling and padding */
/* This targets all modal-body inside this dialog, but the clean-list-body
   will add more specific styling. */
#confirmModalDialog .modal-body {
  max-height: 13rem !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding: 0.6rem 0.9rem !important;
  background: transparent;
  -webkit-overflow-scrolling: touch;
}

/* The clean-list-body provides the visual container for the list */
.clean-list-body {
  max-height: 13rem !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding: 0.4rem 0.6rem !important;
  background: #fafafa;
  border-radius: 6px;
  /* ensure the scroll container starts at top and doesn't collapse */
  display: block;
}
.modal-content {
  background: var(--surface);
}
.modal-title {
  color: var(--text-primary);
}
/* Reset UL defaults so no unexpected spacing hides first items */
.clean-file-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Each item is a clean card-like row */
.clean-file-item {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 8px 10px;
  margin: 6px 0;
  color: var(--text-primary);
  background: var(--surface-hover);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.02) inset;
  font-size: 0.95rem;
  line-height: 1.3;
  word-break: break-word;
  transition: background 0.12s ease, transform 0.08s ease;
}

/* Hover effect */
.clean-file-item:hover {
  background: var(--surface-active);
  transform: translateY(-2px);
}
.btn-close {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23ff0000' viewBox='0 0 16 16'%3E%3Cpath d='M4.646 4.646a.5.5 0 016.708 6.708L8 8.707l-3.354 3.354a.5.5 0 11-.708-.708L7.293 8 4.646 5.354a.5.5 0 010-.708z'/%3E%3C/svg%3E");
  width: 1rem;
  height: 1rem;
  opacity: 1;
}

/* Number column */
.file-number {
  font-weight: 600;
  color: var(--text-primary);
  min-width: 26px;
  flex: 0 0 26px;
  text-align: right;
}

/* File text — allow wrapping and long names */
.file-text {
  flex: 1 1 auto;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.btn-icon-close {
  /* Basic button styling */
  padding: 0.5rem;
  background: transparent;
  border: none;
  font-size: 1.25rem; /* Adjust icon size */
  color: var(--text-primary); /* Set the icon color */
  /* Match Bootstrap's default opacity */
  cursor: pointer;
}

.btn-icon-close:hover {
  opacity: 0.75; /* Hover effect */
  color: var(--text-secondary); /* Ensure color stays */
}

/* Ensure no child causes horizontal overflow */
#confirmModalDialog .modal-body > * {
  width: 100% !important;
  min-width: 0 !important; /* allows flex children to shrink and wrap */
}

/* Styled vertical scrollbar (Webkit: Chrome / Safari) */
.clean-list-body::-webkit-scrollbar {
  width: 10px;
}
.clean-list-body::-webkit-scrollbar-track {
  background: transparent;
}
.clean-list-body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
.clean-list-body::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.18);
}

/* Firefox scrollbar appearance */
@supports (scrollbar-width: thin) {
  .clean-list-body {
    scrollbar-width: thin;
    scrollbar-color: var(--scroll-thumb) transparent;
  }
}

/* Header / footer spacing improvements */
#confirmModalDialog .modal-header {
  padding: 0.9rem 1rem 0.5rem 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
#confirmModalDialog .modal-title {
  font-weight: 600;
  font-size: 1.05rem;
}
#confirmModalDialog .modal-footer {
  padding: 0.6rem 1rem 1rem 1rem;
  border: none;
}

/* Accessibility: ensure focus outlines are visible on keyboard navigation */
.clean-file-item:focus {
  outline: 3px solid rgba(66, 153, 225, 0.18);
  outline-offset: 2px;
}

/* If you find the scroll still not starting at the top (rare), the following
   forces initial visual position — this is purely CSS and safe:
*/
.clean-list-body {
  scroll-behavior: auto;
}
</style>
